import React from 'react'
import IconBase from './IconBase'

const Cross = props =>
  <IconBase viewBox="0 0 40 40" {...props}>
    <g transform="translate(-790.63 -1385.6)">
      <path d="m829.3 1393.5l-12.1 12.1 12.1 12.1c1.8 1.8 1.8 4.7 0 6.5s-4.7 1.8-6.5 0l-12.1-12.1-12.1 12.1c-1.8 1.8-4.7 1.8-6.5 0s-1.8-4.7 0-6.5l12.1-12.1-12.1-12.1c-1.8-1.8-1.8-4.7 0-6.5s4.7-1.8 6.5 0l12.1 12.1 12.1-12.1c1.8-1.8 4.7-1.8 6.5 0s1.8 4.7 0 6.5z"/>
    </g>
  </IconBase>

export default Cross
